// @flow
import React, { Component } from 'react';
import classNames from 'classnames/bind';
import { defineMessages, FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import style from '../Payouts.scss';
import commonStyle from '../../../PreferencesViewCommon.scss';
import buttonStyle from '../../../../../assets/styles/button.scss';
import RadioButton from '../../../../../elements/RadioButton/RadioButton';
import boxStyle from '../../../../../assets/styles/box.scss';

import type { DisbursementMethod } from '../../../../../entities';

type Props = {
  methods: DisbursementMethod[];
  method: string;
  handleChange: (e: SyntheticInputEvent<HTMLInputElement>) => void;
  handleBack: (e: Event) => void;
  handleSubmit: (e: Event) => void;
};

const messages = defineMessages({
  methods: {
    label: {
      id: 'preferences.payouts.methods.label',
    },
    BANK_ACCOUNT: {
      id: 'preferences.payouts.methods.bankTransfer',
    },
    PAYPAL: {
      id: 'preferences.payouts.methods.paypal',
    },
  },
  button: {
    back: {
      id: 'preferences.payouts.button.back',
    },
    next: {
      id: 'preferences.payouts.button.next',
    },
  },
});

export default class MethodStep extends Component<Props> {
  render() {
    const { methods, method, handleChange, handleBack, handleSubmit } = this.props;
    const options = methods && methods.map((m: DisbursementMethod, index: number) =>
      <RadioButton key={index}
                   name="method"
                   value={m.disbursementMethod}
                   selected={method}
                   handleChange={handleChange}>
        <FormattedMessage id={messages.methods[m.disbursementMethod].id}>{
          txt => <span className={style.buttonLabel}>{txt}</span>
        }</FormattedMessage>
      </RadioButton>
    );
    return [
      <FormattedMessage key="title"
                        id="preferences.payouts.stepMethod.title">{
        txt => <h2 className={classNames(boxStyle.boxTitle, boxStyle.smallSpace)}>{txt}</h2>
      }</FormattedMessage>,
      <form key="form"
            className={style.methodForm}>
        <article className={style.radioWrap}>
          {options}
        </article>
        <section className={classNames(commonStyle.buttonsRow, commonStyle.buttons)}>
          <FormattedMessage id={messages.button.back.id}>{
            txt => <button type="button"
                           className={classNames(buttonStyle.btn, buttonStyle.darkGrey)}
                           onClick={handleBack}>
              {txt}</button>
          }</FormattedMessage>
          <FormattedMessage id={messages.button.next.id}>{
            txt => <button type="button"
                           disabled={method === ''}
                           className={classNames(buttonStyle.btn, buttonStyle.lightBlue)}
                           onClick={handleSubmit}>
              {txt}</button>
          }</FormattedMessage>
        </section>
      </form>];
  }
}

MethodStep.propTypes = {
  methods: PropTypes.array.isRequired,
  method: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBack: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/preferences/payouts/components/MethodStep/MethodStep.jsx